import { useQuery } from '@tanstack/react-query';

import { ONE_ON_ONE_SIDE_BAR_REACT_QUERY_KEYS } from '../../../constants';
import { getPastOneOnOne } from '../service';

export const usePastOneOnOnes = ({ masterId }: { masterId: number }) =>
  useQuery([ONE_ON_ONE_SIDE_BAR_REACT_QUERY_KEYS.PAST_ONE_ON_ONE, masterId], () => getPastOneOnOne({ masterId }));
